import mixinInput from '/@mixins/input'

export default {
  mixins: [mixinInput],
  computed: {
    textAreaValue: {
      get() {
        return this.value
      },
      set(value) {
        this.emitValue(value)
      },
    },
  },
}
